import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPaypal } from '@fortawesome/free-brands-svg-icons';
import { faCreditCard } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowLeft,
  faAt,
  faClose,
  faMoneyBill1,
  faMugHot,
  faWallet,
} from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ToastrService } from 'ngx-toastr';
import { Subject, distinctUntilChanged, finalize, takeUntil } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { appVersion } from '../../../../app.component';
import { PaymentCodes, ProductNames } from '../../../../models/app-enums';
import { selectIp, selectUser } from '../../../../ngrx/data.reducer';
import { CommonService } from '../../../../services/common.service';
import { HelperService } from '../../../../services/helper.service';
import { HttpService } from '../../../../services/http.service';
import { LoaderService } from '../../../../services/loader.service';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { InputComponent } from '../../../../shared/input/input.component';
import { StripeFormComponent } from '../../../../shared/stripe-form/stripe-form.component';
import { DirectivesModule } from '../../../../tsExtras/directives.module';

declare var $: any;
@Component({
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    LazyLoadImageModule,
    DirectivesModule,
    StripeFormComponent,
    InputComponent,
  ],
  selector: 'app-buymecoffee-modal',
  templateUrl: './buymecoffee-modal.component.html',
  styleUrls: ['./buymecoffee-modal.component.scss'],
})
export class BuymecoffeeModalComponent implements OnInit, OnDestroy {
  faClose = faClose;
  faArrowLeft = faArrowLeft;
  faCard = faCreditCard;
  faPayPal = faPaypal;
  faMoneyBill1 = faMoneyBill1;
  faWallet = faWallet;
  faMugHot = faMugHot;
  faAt = faAt;
  @Input() creatorId: number;
  @Input() creatorName: string;
  @Input() creatorEmail: string;
  @Output() url: EventEmitter<any> = new EventEmitter<any>();
  showSupportDetails: boolean = true;
  showPaymentGateways: boolean = false;
  selectedPayment: any;
  isStripeActive: boolean = false;
  isPaypalActive: boolean = false;
  isWaleeActive: boolean = false;
  isEasyPaisaActive: boolean = false;
  isWalletActive: boolean = false;
  showStripeForm: boolean = false;
  userDetails: any = null;
  creatorDetails: any = JSON.parse(localStorage.getItem('creatorDetails'));
  description: string = null;
  noOfCoffee: number = 1;
  perCoffeePrice: number = 3;
  btnPrice: number = this.perCoffeePrice;
  paymentTypes = PaymentCodes;
  paymentSuccessModel = {} as any;
  selectedButton: number = 1;
  menteeId: any = '';
  currentUrl: string = null;
  userEmail: string = null;
  user$ = this.store.select(selectUser);
  private destroy$ = new Subject<void>();
  ip$ = this.store.select(selectIp);
  ipData;
  StripeModalForm: FormGroup = this.fb.group({
    number: ['', [Validators.required]],
    expMonth: ['', [Validators.required]],
    expYear: ['', [Validators.required]],
    cvc: ['', [Validators.required]],
  });
  GuestForm = this.formBuilder.group({
    id: [null],
    email: ['', [Validators.required, Validators.email]],
  });
  constructor(
    private http: HttpService,
    private formBuilder: FormBuilder,
    private _commonService: CommonService,
    private helper: HelperService,
    private toaster: ToastrService,
    private router: Router,
    private store: Store,
    private mixPanelService: MixpanelService,
    private fb: FormBuilder,
  ) {
    this.user$
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((user) => {
        this.userDetails = user;
      });
    this.ip$
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((ip: any) => {
        this.ipData = ip;
      });
  }

  ngOnInit(): void {
    this.getPaymentGateways();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.StripeModalForm.reset();
  }

  openPaymentGateways() {
    this.showSupportDetails = false;
    this.showPaymentGateways = true;
    this.proceedToPayment();
  }
  proceedToPayment() {
    this._commonService.pixelAction(
      'Proceed to Payment',
      this.userDetails?.id,
      this.router.url,
      this.creatorName,
      'Coffee',
      this.btnPrice,
      this.creatorEmail,
      null,
      null,
      null,
      this.noOfCoffee + ' Coffee',
      this.creatorDetails?.mentorDetails[0]?.userName,
    );
  }
  onPaymentChange(val) {
    this.selectedPayment = val.target.value;
  }
  GoBackPage1() {
    this.showSupportDetails = true;
    this.showPaymentGateways = false;
    this.isStripeActive = false;
  }

  GoBackPage2() {
    this.selectedPayment = null;
    this.showPaymentGateways = true;
    this.showStripeForm = false;
    this.isStripeActive = false;
  }

  getPaymentGateways() {
    this.http
      .loaderGet('api/home/paymentDetails', true, false)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          LoaderService.loader.next(false);
        }),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((response) => {
        if (response.status) {
          let paymentGateways = response.objModelList;
          paymentGateways.forEach((element) => {
            if (element.paymentCode == PaymentCodes.Stripe) {
              this.isStripeActive = true;
            }
            if (element.paymentCode == PaymentCodes.PayPal) {
              this.isPaypalActive = true;
            }
            if (element.paymentCode == PaymentCodes.JazzCash) {
              this.isWaleeActive = true;
            }
            if (element.paymentCode == PaymentCodes.EasyPaisa) {
              this.isEasyPaisaActive = true;
            }
            if (element.paymentCode == PaymentCodes.Wallet) {
              this.isWalletActive = true;
            }
          });
        }
      });
  }
  appendQuantity(quantity) {
    this.selectedButton = quantity;
    if (!isNaN(quantity)) {
      this.noOfCoffee = quantity;
    } else {
      quantity = Number(quantity.target.value);
    }
    this.btnPrice = quantity * 3;
  }
  sendProceedToPaymentEvent(paymentGateWay, paymentMethod) {
    this._commonService.pixelAction(
      'Proceed to Payment',
      this.menteeId,
      this.currentUrl,
      this.creatorName?.toLowerCase(),
      'Coffee',
      this.btnPrice,
      this.creatorEmail?.toLowerCase(),
      paymentGateWay,
      paymentMethod,
      null,
      'Coffee',
      this.creatorDetails?.mentorDetails[0]?.userName,
    );
  }
  async continuePayment() {
    if (this.selectedPayment) {
      this.userEmail = this.userDetails?.email || null;
      this.showPaymentGateways = false;
      if (this.selectedPayment == this.paymentTypes.Stripe) {
        this.showStripeForm = true;
        this.mixPanelService.trackProductEvent(
          'Payment-Method-Selected',
          this.creatorDetails?.fullName,
          'Coffee',
          this.noOfCoffee + ' Coffee',
          this.btnPrice,
          this.creatorDetails?.mentorDetails[0]?.userName,
          'stripe',
          'card',
        );
      } else if (this.selectedPayment == this.paymentTypes.PayPal) {
        localStorage.setItem('functionToCall', 'buyMeCoffee');
        if (this.userDetails) {
          this.paypalPayment();
        } else {
          this.guestUser('paypal');
        }
        this.mixPanelService.trackProductEvent(
          'Payment-Method-Selected',
          this.creatorDetails?.fullName,
          'Coffee',
          this.noOfCoffee + ' Coffee',
          this.btnPrice,
          this.creatorDetails?.mentorDetails[0]?.userName,
          'paypal',
          'paypal',
        );
      } else if (this.selectedPayment == this.paymentTypes.Wallet) {
        const body = {
          mentorId: this.creatorId,
          menteeId: this.userDetails?.id,
          supportingEmail: this.userEmail,
          amount: 3,
          quantity: this.noOfCoffee,
          isRecurring: false,
          description: this.description,
          phoneNo: null,
          ip: this.ipData?.ip,
          os: this.helper.detectOS(),
          version: appVersion,
        };
        this.mixPanelService.trackProductEvent(
          'Payment-Method-Selected',
          this.creatorDetails?.fullName,
          'Coffee',
          this.noOfCoffee + ' Coffee',
          this.btnPrice,
          this.creatorDetails?.mentorDetails[0]?.userName,
          'wallet',
          'wallet',
        );
        this.http
          .loaderPost(
            'api/Payment/support-mentor-wallet-payment',
            body,
            true,
            false,
          )
          .pipe(
            takeUntil(this.destroy$),
            finalize(() => {
              LoaderService.loader.next(false);
              this.helper.hideModal();
            }),
            distinctUntilChanged(
              (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
            ),
          )
          .subscribe(
            (response) => {
              this.mixPanelService.trackProductEvent(
                'Payment-Completed',
                this.creatorDetails?.fullName,
                'Coffee',
                this.noOfCoffee + ' Coffee',
                this.btnPrice,
                this.creatorDetails?.mentorDetails[0]?.userName,
                'Wallet',
                'Wallet',
              );
              this.showStripeForm = false;
              this.showSupportDetails = true;
              this.toaster.success('Successfully Sent!');
            },
            (err) => {
              this.showPaymentGateways = true;
              this.selectedPayment = null;
            },
          );
      } else if (this.selectedPayment == this.paymentTypes.JazzCash) {
        localStorage.setItem('functionToCall', 'buyMeCoffee');
        this.mixPanelService.trackProductEvent(
          'Payment-Method-Selected',
          this.creatorDetails?.fullName,
          'Coffee',
          this.noOfCoffee + ' Coffee',
          this.btnPrice,
          this.creatorDetails?.mentorDetails[0]?.userName,
          'paymob',
          'jazzCash',
        );
        this.jazzCashHandler();
      } else if (this.selectedPayment == this.paymentTypes.EasyPaisa) {
        localStorage.setItem('functionToCall', 'buyMeCoffee');
        this.mixPanelService.trackProductEvent(
          'Payment-Method-Selected',
          this.creatorDetails?.fullName,
          'Coffee',
          this.noOfCoffee + ' Coffee',
          this.btnPrice,
          this.creatorDetails?.mentorDetails[0]?.userName,
          'paymob',
          'easyPaisa',
        );
        this.easyPaisaHandler();
      }
    } else {
      this.toaster.info('Select payment method!');
    }
  }
  jazzCashHandler() {
    this.paymentSuccessModel = {
      bookingNo: '',
      bookingAmount: this.btnPrice,
      creatorURL: this.creatorDetails?.mentorDetails[0]?.userName,
      mentorName: this.creatorDetails?.fullName,
      paymentType: this.paymentTypes.PayPal,
      product: ProductNames.Coffee,
      productType: this.noOfCoffee,
      paymentMethod: 'JazzCash',
      paymentGateway: 'Paymob',
    };
    localStorage.setItem(
      'paymentSuccessModel',
      JSON.stringify(this.paymentSuccessModel),
    );
    const url = `${environment.apiUrl}api/payment/paymob-support-payment?PaymentMethodCode=${this.paymentTypes.JazzCash}&Amount=${this.btnPrice}&Quantity=${this.noOfCoffee}&MenteeId=${this.userDetails?.id}&MentorId=${this.creatorId}&Description=${this.description}`;
    this.helper.hideModal();
    LoaderService.loader.next(false);
    if (this.userDetails?.phone) {
      window.open(url, '_self');
    } else {
      this.url.emit(url);
      this.helper.showModal(true, 'guestPhone');
    }
  }
  easyPaisaHandler() {
    this.paymentSuccessModel = {
      bookingNo: '',
      bookingAmount: this.btnPrice,
      creatorURL: this.creatorDetails?.mentorDetails[0]?.userName,
      mentorName: this.creatorDetails?.fullName,
      paymentType: this.paymentTypes.PayPal,
      product: ProductNames.Coffee,
      productType: this.noOfCoffee,
      paymentMethod: 'EasyPaisa',
      paymentGateway: 'Paymob',
    };
    localStorage.setItem(
      'paymentSuccessModel',
      JSON.stringify(this.paymentSuccessModel),
    );
    const url = `${environment.apiUrl}api/payment/paymob-support-payment?PaymentMethodCode=${this.paymentTypes.EasyPaisa}&Amount=${this.btnPrice}&Quantity=${this.noOfCoffee}&MenteeId=${this.userDetails?.id}&MentorId=${this.creatorId}&Description=${this.description}`;
    this.helper.hideModal();
    LoaderService.loader.next(false);
    if (this.userDetails?.phone) {
      window.open(url, '_self');
    } else {
      this.url.emit(url);
      this.helper.showModal(true, 'guestPhone');
    }
  }
  StripePayment() {
    const body = {
      number: this.StripeModalForm.controls['number'].value,
      expMonth: this.StripeModalForm.controls['expMonth'].value,
      expYear: this.StripeModalForm.controls['expYear'].value,
      cvc: this.StripeModalForm.controls['cvc'].value,
      paymentCode: PaymentCodes.Stripe,
      mentorId: this.creatorId,
      menteeId: this.userDetails
        ? this.userDetails?.id
        : this.GuestForm?.controls['id'].value,
      email: this.userDetails
        ? this.userEmail
        : this.GuestForm?.controls['email'].value,
      amount: 1,
      quantity: this.noOfCoffee,
      isRecurring: false,
      description: this.description,
      stripeProductId: null,
      ip: this.ipData?.ip,
      os: this.helper.detectOS(),
      version: appVersion,
    };
    this.http
      .loaderPost('api/payment/support-mentor-card', body, true, true)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.StripeModalForm.reset();
          this.showStripeForm = false;
          this.showSupportDetails = true;
        }),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe(
        (response) => {
          this.mixPanelService.trackProductEvent(
            'Payment-Completed',
            this.creatorDetails?.fullName,
            'Coffee',
            this.noOfCoffee + ' Coffee',
            this.btnPrice,
            this.creatorDetails?.mentorDetails[0]?.userName,
            'Stripe',
            'Card',
          );
          this.helper.hideModal();
          LoaderService.loader.next(false);
          this.toaster.success('Successfully Sent!');
        },
        (err) => {
          this.selectedPayment = null;
        },
      );
  }
  guestUser(name) {
    const data = {
      email: this.GuestForm?.controls['email'].value,
      productId: 0,
      slotId: 0,
      contactId: 0,
    };
    this.http
      .loaderPost('api/Guest/add-guest-by-email', data, false, false)
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((response) => {
        localStorage.removeItem('guestDetails');
        localStorage.removeItem('guestUser');
        this.GuestForm.patchValue({
          id: response?.model?.id,
        });
        if (name == 'stripe') {
          this.StripePayment();
        } else {
          const guestUser = {
            id: response?.model?.id,
            email: this.GuestForm?.controls['email'].value,
            isNewUser: response?.model?.isNewUser,
            name: response?.model?.name,
            thirdPartyRegistration: response?.model?.thirdPartyRegistration,
            token: response?.model?.token,
            flow: 'coffee',
          };
          localStorage.setItem('guestUser', JSON.stringify(guestUser));
          this.paypalPayment();
        }
      });
  }
  paypalPayment() {
    this.toaster.info('Please wait');
    this.showSupportDetails = true;
    const body = {
      mentorId: this.creatorId,
      menteeId: this.userDetails
        ? this.userDetails?.id
        : this.GuestForm?.controls['id'].value,
      supportingEmail: this.userDetails
        ? this.userEmail
        : this.GuestForm?.controls['email'].value,
      amount: 3,
      quantity: this.noOfCoffee,
      isRecurring: false,
      description: this.description,
      phoneNo: null,
      ip: this.ipData?.ip,
      os: this.helper.detectOS(),
      version: appVersion,
    };
    this.http
      .loaderPost('api/payment/support-mentor-paypal', body, false, false)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.helper.hideModal();
        }),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((response) => {
        this.paymentSuccessModel = {
          bookingNo: '',
          bookingAmount: this.btnPrice,
          creatorURL: this.creatorDetails?.mentorDetails[0]?.userName,
          mentorName: this.creatorDetails?.fullName,
          paymentType: this.paymentTypes.PayPal,
          product: ProductNames.Coffee,
          productType: this.noOfCoffee,
          paymentMethod: 'Paypal',
          paymentGateway: 'Paypal',
        };
        localStorage.setItem(
          'paymentSuccessModel',
          JSON.stringify(this.paymentSuccessModel),
        );
        window.location.href = response.model.links.filter(
          (link) => link.rel == 'approve',
        )[0].href;
      });
  }
}
